const API_BASE = '/api';

async function request(url, options = {}) {
  const res = await fetch(`${API_BASE}${url}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok && res.status === 401) {
    // Redirect to landing page login
    window.location.href = 'https://msalgoai.com';
    return { error: 'Unauthorized' };
  }
  return await res.json();
}

// ── Auth ──
export async function checkSession() {
  try {
    return await request('/auth/check');
  } catch {
    return { valid: false };
  }
}

// ── System Status ──
export async function getSystemStatus() {
  return request('/admin/status');
}

// ── Apps ──
export async function getApps() {
  return request('/admin/apps');
}

export async function reorderApps(arrangement) {
  return request('/admin/apps/reorder', {
    method: 'POST',
    body: JSON.stringify({ arrangement }),
  });
}

export async function toggleApp(appId, enabled) {
  return request(`/admin/apps/${appId}/toggle`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

// ── Resources ──
export async function getCPU() {
  return request('/admin/resources/cpu');
}

export async function getMemory() {
  return request('/admin/resources/memory');
}

// ── Settings ──
export async function changePassword(oldPassword, newPassword, confirmPassword) {
  return request('/admin/password/change', {
    method: 'POST',
    body: JSON.stringify({ oldPassword, newPassword, confirmPassword }),
  });
}

// ── Errors ──
export async function getErrors() {
  return request('/admin/errors');
}

export async function clearErrors() {
  return request('/admin/errors', { method: 'DELETE' });
}

// ── Safe Mode ──
export async function activateSafeMode() {
  return request('/admin/safemode/activate', { method: 'POST' });
}

export async function deactivateSafeMode() {
  return request('/admin/safemode/deactivate', { method: 'POST' });
}

// ── Config ──
export async function loadConfig() {
  return request('/admin/config/load');
}

export async function saveConfig(config) {
  return request('/admin/config/save', {
    method: 'POST',
    body: JSON.stringify(config),
  });
}
